// extracted by mini-css-extract-plugin
module.exports = {"promo_bonus_container_open":"PromoGridTable_promo_bonus_container_open__7fSeB","bonus_terms":"PromoGridTable_bonus_terms__PfjRA"};